import type { ReactNode } from 'react'

interface HomeFabDockProps {
  children: ReactNode
}

export function HomeFabDock({ children }: HomeFabDockProps) {
  return <div className="home-fab-dock">{children}</div>
}
